import { createContext, Dispatch, SetStateAction } from 'react'

export const PanNumberContext = createContext<{
  maskedPanNumber: string | undefined
  setMaskedPanNumber: Dispatch<SetStateAction<string | undefined>>
}>({
  maskedPanNumber: undefined,
  setMaskedPanNumber: () => {},
})
